import { render, staticRenderFns } from "./pingbox.vue?vue&type=template&id=459e9af2&scoped=true&"
import script from "./pingbox.vue?vue&type=script&lang=js&"
export * from "./pingbox.vue?vue&type=script&lang=js&"
import style0 from "./pingbox.vue?vue&type=style&index=0&id=459e9af2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459e9af2",
  null
  
)

export default component.exports